// extracted by mini-css-extract-plugin
module.exports = {"container":"SimplifyBenefit_container__OMuIv","contentGroup":"SimplifyBenefit_contentGroup__CIiwD","divider":"SimplifyBenefit_divider__zu___"};